module.exports = __webpack_public_path__ + "static/media/2_duplex_B_aqua_square.c229c994.png";